<!-- 成功提示弹窗 -->
<template>
  <el-dialog
    ref="successDialogRef"
    :visible.sync="show"
    :show-close="true"
    :before-close="handleDialogClose"
    width="424px"
    top="35vh"
    custom-class="success-dialog"
    center
  >
    <div class="success-dialog-content">
      <div class="success-icon">
        <i class="el-icon-circle-check"></i>
      </div>
      <div class="success-text">
        <img :src="require('@/img/pc/follow/success-left.png')" />
        <div class="text">{{ SuccessTitle }}</div>
        <img :src="require('@/img/pc/follow/success-right.png')" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SuccessDialog",
  data() {
    return {
      showSuccessDialog: false, // 控制成功弹窗的显示状态
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    SuccessTitle: {
      type: String,
      default: "恭喜您抢单成功！",
    },
  },
  methods: {
    handleDialogClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
/* 成功弹窗样式 */
.success-dialog {
  border-radius: 4px !important;

  ::v-deep .el-dialog__header {
    display: none;
  }
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }
}

// 成功弹窗内容样式
.success-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 42px;

  // 成功图标样式
  .success-icon {
    margin-bottom: 15px;

    i {
      font-size: 60px !important;
      color: #518ff2;
    }
  }
  // 成功文字样式
  .success-text {
    font-size: 18px;
    color: #3d3d3d;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 30px;
      height: 30px;
    }
    .text {
      margin: 6px 0 0 10px;
    }
  }
}
</style>
